import './../polyfills';
// Just for getting all global styles
import './../styles/global.scss';

import ImpersonationBarComponent from '@/public/impersonation/components/impersonation-bar/impersonation-bar-component.vue';
import CandidateLocationComponent from '@/shared/components/candidate-location-component/candidate-location-component.vue';
import CookieBar from '@/shared/components/cookie-bar-component/cookie-bar-component.vue';
import DebugComponent from '@/shared/components/debug-component/debug-component.vue';
import FileArchiveComponent from '@/shared/components/file-archive-component/file-archive-component.vue';
import LinkListComponent from '@/shared/components/link-list-component/link-list-component.vue';
import LinkManagerComponent from '@/shared/components/link-manager/components/link-manager-component/link-manager-component.vue';
import PreloaderComponent from '@/shared/components/preloader-component/preloader-component.vue';
import Vue from 'vue';
import { ModuleLoader } from '@/module-loader';
import ModalComponent from './components/modal-component/modal-component.vue';
import CandidateListComponent from './election/components/candidate-list-component/candidate-list-component.vue';
import NominationComponent from './nomination/components/nomination-component/nomination-component.vue';
import CandidateProfileModalComponent from './shared/components/candidate-profile-modal-component/candidate-profile-modal-component.vue';
import CandidateProfilePictureComponent from './shared/components/candidate-profile-picture-component/candidate-profile-picture-component.vue';
import ActivityMeetingComponent from './activity/meeting/components/activity-meeting-component/activity-meeting-component.vue';
import StandaloneElectionVoteComponent from './vote/components/standalone-election-vote-component/standalone-election-vote-component.vue';
import ElectionSignUpComponent from './election/components/election-signup-component/election-signup-component.vue';
import MetricsMenuItemComponent from './metrics/metrics-menu-item-component/metrics-menu-item-component.vue';
import HtmlEditorComponent from '@/shared/components/html-editor-component/html-editor-component.vue';
import MyNomineesComponent from '@/public/nomination/components/my-nominees-component/my-nominees-component.vue';
import PaginationComponent from '@/shared/components/pagination-component/pagination-component.vue';
import IdentityCardMenuItemComponent from '@/public/identity-card/identity-card-menu-item-component/identity-card-menu-item-component.vue';
import ActivityMotioningComponent from '@/public/activity/motioning/components/activity-motioning-component/activity-motioning-component.vue';
import UserTaskListComponent from '@/public/overview/components/user-task-list-component/user-task-list-component.vue';
import MyMotionsComponent from './motioning/components/my-motions-component/my-motions-component.vue';

Vue.component('debugComponent', DebugComponent);
Vue.component('preloaderComponent', PreloaderComponent);
Vue.component('pagination', PaginationComponent);
Vue.component('modalComponent', ModalComponent);
Vue.component('evLinkList', LinkListComponent);

ModuleLoader.init('easyvote-candidate-profile-modal-component', CandidateProfileModalComponent);
ModuleLoader.init('easyvote-candidate-profile-picture-component', CandidateProfilePictureComponent);
ModuleLoader.init('easyvote-candidate-location-component', CandidateLocationComponent);
ModuleLoader.init('easyvote-candidate-list-component', CandidateListComponent);
ModuleLoader.init('easyvote-standalone-election-vote-component', StandaloneElectionVoteComponent);
ModuleLoader.initMany('easyvote-nomination-component', NominationComponent);
ModuleLoader.init('easyvote-impersonation-bar', ImpersonationBarComponent);
ModuleLoader.init('easyvote-activity-meeting', ActivityMeetingComponent);
ModuleLoader.init('easyvote-activity-motioning', ActivityMotioningComponent)
ModuleLoader.init('easyvote-election-signup-component', ElectionSignUpComponent);
ModuleLoader.init('easyvote-metrics-menu-item-component', MetricsMenuItemComponent);
ModuleLoader.init('easyvote-my-nominees-component', MyNomineesComponent)
ModuleLoader.init('easyvote-my-motions-component', MyMotionsComponent);
ModuleLoader.init('easyvote-identity-card-menu-item-component', IdentityCardMenuItemComponent);
ModuleLoader.init('easyvote-user-task-list', UserTaskListComponent);

// Shared
ModuleLoader.init('easyvote-cookie-bar-component', CookieBar);
ModuleLoader.init('easyvote-link-manager-component', LinkManagerComponent);
ModuleLoader.init('easyvote-link-list-component', LinkListComponent);
ModuleLoader.init('easyvote-file-archive', FileArchiveComponent);
ModuleLoader.initMany('easyvote-html-editor-component', HtmlEditorComponent);
